<template>
	<div
		class="steps__step"
		:class="( is_completed_step ) ? ' steps__step--completed' : ( is_current_step ) ? ' steps__step--active' : null"
	>
		<div class="steps__step-number">
			{{ step.step_number }}
		</div>
		<div class="steps__step-title-wrapper">
			<h2 class="steps__step-title">
				{{ step.title }}
			</h2>
		</div>
		<template v-if="is_current_step">
			<div class="steps__step-form">
				<form
					@submit.prevent="updateForm"
				>
					<div class="mb-24">
						<h3 class="">
							Project name
						</h3>
						<p class="h5">
							XXXXX {{ client_short_code ? client_short_code + ' ' : '' }}{{ form_fields.project_name }}
						</p>
					</div>
					<div class="notice-bar mb-24">
						<p>
							The project name will take the next available project number, the Company Short Code as defined by the Client Company entry and then the name you have provided in Step 1
						</p>
					</div>
					<InputComponent
						:value="form_fields.notify_slack_channel"
						type="checkbox"
						input-id="send-slack-notification"
						name="send-slack-notification"
						label="Send notification to slack channel"
						:errors="form_errors.notify_slack_channel || null"
						@update:value="new_value => form_fields.notify_slack_channel = new_value"
					/>
					<div class="notice-bar mb-24">
						<p>
							<b>Take a moment to review your information before creating the project</b><br>
							You can edit any section right from this page
						</p>
					</div>
					<button
						class="button button--fill"
						:class="{ 'button--loading': loading}"
						type="submit"
						:disabled="loading"
					>
						Create Project
					</button>
				</form>
			</div>
		</template>
	</div>
</template>

<script setup>
import { useNewProjectStore } from '../../stores/new-project.js';
import { ref, computed, defineProps } from 'vue';
import { storeToRefs } from 'pinia';
import InputComponent from '../InputComponent';

const new_project_store = useNewProjectStore();
const { submitNewProject } = new_project_store;

const {
	selected_client,
	form_fields,
	form_errors
} = storeToRefs( new_project_store );

const props = defineProps( {
	step: {
		required: true,
		type: Object
	},
	activeStepNumber: {
		required: true,
		type: Number
	}
} );

const is_current_step = computed( () => {
	return props.step.step_number === props.activeStepNumber;
} );

const is_completed_step = computed( () => {
	return props.step.step_number < props.activeStepNumber;
} );

const client_short_code = computed( () => {
	if ( !selected_client.value ) {
		return null;
	}
	return selected_client.value.element.company_short_code ?? null;
} );

const loading = ref( false );

async function updateForm() {
	loading.value = true;
	await submitNewProject();
	loading.value = false;
}
</script>
